import React from "react";
import { bagSvg, cartFullSvg } from "./svg";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BasketFull(_ref) {
  var checkKYCStatus = _ref.checkKYCStatus,
    isCheckout = _ref.isCheckout,
    placeOrder = _ref.placeOrder,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var dealAction = redux === null || redux === void 0 ? void 0 : redux.dealAction;
  return /*#__PURE__*/_jsx("div", {
    id: "NoRewards",
    children: /*#__PURE__*/_jsx("div", {
      "class": "flex flex-col items-center justify-center py-8  bg-white border border-gray-300 rounded-lg shadow-sm  w-[95%] md:w-[70%] lg:w-[50%] mx-auto mt-14",
      children: /*#__PURE__*/_jsxs("div", {
        "class": " flex flex-col lg:flex-row items-center gap-2",
        children: [/*#__PURE__*/_jsx("div", {
          "class": "",
          children: cartFullSvg
        }), /*#__PURE__*/_jsx("hr", {
          className: " hidden lg:block h-24 w-[2px] bg-gray-100 mx-3"
        }), /*#__PURE__*/_jsx("hr", {
          className: " block lg:hidden w-32 h-[2px] bg-gray-100 mt-2"
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col items-center lg:items-start",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex flex-col items-center justify-center lg:items-start text-center",
            children: [/*#__PURE__*/_jsx("h3", {
              "class": "text-lg md:text-xl font-bold mt-2 lg:mt-0 ",
              children: "Your Gift Basket is Full"
            }), isCheckout && /*#__PURE__*/_jsxs("p", {
              className: " text-sm ",
              children: ["Proceed to", " ", /*#__PURE__*/_jsx("a", {
                onClick: placeOrder,
                className: "text-blue-800 text-sm  cursor-pointer",
                children: "Place Order"
              }), " ", "or Remove some Items to see other rewards."]
            }), !isCheckout && /*#__PURE__*/_jsxs("p", {
              className: " text-sm mt-2",
              children: ["Continue to", " ", /*#__PURE__*/_jsx("a", {
                onClick: function onClick() {
                  return checkKYCStatus();
                },
                className: "text-blue-800 text-sm  cursor-pointer",
                children: "Checkout"
              }), " ", "or", " ", /*#__PURE__*/_jsx("a", {
                // onClick={(event) => {
                //     event.stopPropagation();
                //     window.dispatchEvent(
                //         new Event('cartUpdated')
                //     );
                //     dispatch(
                //         dealAction.setCartModalVisible(
                //             true
                //         )
                //     );
                // }}
                onClick: function onClick(event) {
                  event.stopPropagation();
                  window.dispatchEvent(new CustomEvent("cartUpdated", {
                    detail: {
                      showModal: true
                    }
                  }));
                  if (dispatch && dealAction !== null && dealAction !== void 0 && dealAction.setCartModalVisible) {
                    dispatch(dealAction.setCartModalVisible(true));
                  }
                },
                className: "text-blue-800 text-sm cursor-pointer",
                children: "Remove Some Items"
              }), " ", "to see other rewards."]
            })]
          }), /*#__PURE__*/_jsxs("button", {
            "class": "px-4 py-2  text-sm  text-white bg-primary  rounded-md  mt-3 flex items-center gap-2",
            onClick: function onClick(event) {
              event.stopPropagation();
              if (isCheckout) {
                placeOrder();
                return;
              }
              window.dispatchEvent(new CustomEvent("cartUpdated", {
                detail: {
                  showModal: true
                }
              }));
              if (dispatch && dealAction !== null && dealAction !== void 0 && dealAction.setCartModalVisible) {
                dispatch(dealAction.setCartModalVisible(true));
              }
            },
            children: [bagSvg, " ", /*#__PURE__*/_jsx("span", {
              children: isCheckout ? "Place Order" : "Go To Gift Basket"
            })]
          })]
        })]
      })
    })
  });
}
export default BasketFull;